import { IUsersOptionsFilters } from "src/@types/stores";
import { Tags } from "../../enum/tags";
import { apiSlice } from "../http";
import { ISelectOptions, StoreCatalogWire } from "src/@types/select";

export interface IStoreOptionWithDetails {
  value: string;
  label: string;
  nickname?: string;
  address?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
  postalCode?: string;
}

export interface IStoreFilterableOption {
  value: string;
  label: string;
  state: string;
  city: string;
  regionalId: number | null;
  regionalName: string | null;
}

export const storeInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoresCatalog: builder.query<StoreCatalogWire[], void>({
      query: () => ({
        url: `/ofm/catalog`,
        method: "GET",
      }),
      providesTags: [Tags.OPTIONS_OFM_STORE],
      keepUnusedDataFor: 43200, // 12 hours
    }),
    getStoresOptions: builder.query<ISelectOptions, { isAdmin?: boolean } | void>({
      query: (args) => {
        const params = new URLSearchParams({
          orderBy: JSON.stringify({ code: "asc" }),
          ...(args?.isAdmin && { isAdmin: "true" }),
        });
        return {
          url: `/store/options/store?${params.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response: ISelectOptions) => {
        return response || [];
      },
      providesTags: [Tags.OPTIONS_STORE],
    }),
    getStoresResponsiblesOptions: builder.query<
      ISelectOptions,
      IUsersOptionsFilters | void
    >({
      query: (filters) => {
        const params = new URLSearchParams(
          filters as unknown as Record<string, string>
        );
        return {
          url: `/store/options/responsibles?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.OPTIONS_RESPONSIBLE],
    }),
    getRegionalStoresOptions: builder.query<ISelectOptions, void>({
      query: () => {
        return {
          url: `/store/options/regional`,
          method: "GET",
        };
      },
      providesTags: [Tags.OPTIONS_REGIONAL],
    }),
    getRegionalResponsible: builder.query<ISelectOptions, void>({
      query: () => {
        return {
          url: `/store/options/regional-responsible`,
          method: "GET",
        };
      },
      providesTags: [Tags.OPTIONS_REGIONAL],
    }),
    getStoresByRegional: builder.query<{ regional: number; lojas: number[] }, void>({
      query: () => ({
        url: `/store/options/store/regional`,
        method: "GET",
      }),
      providesTags: [Tags.OPTIONS_STORE],
    }),
    getRegisterCodeOptions: builder.query<{ register_code: string }, void>({
      query: () => ({
        url: `/store/options/register-code`,
        method: "GET",
      }),
      providesTags: [Tags.OPTIONS_STORE],
    }),
    getStoresOptionsWithDetails: builder.query<IStoreOptionWithDetails[], void>({
      query: () => ({
        url: `/store/options/store/details`,
        method: "GET",
      }),
      transformResponse: (response: IStoreOptionWithDetails[]) => response || [],
      providesTags: [Tags.OPTIONS_STORE],
    }),
    getStoresFilterableOptions: builder.query<IStoreFilterableOption[], void>({
      query: () => ({
        url: `/store/options/store/filterable`,
        method: "GET",
      }),
      transformResponse: (response: IStoreFilterableOption[]) => response || [],
      providesTags: [Tags.OPTIONS_STORE],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetStoresCatalogQuery,
  useGetStoresOptionsQuery,
  useGetStoresResponsiblesOptionsQuery,
  useGetRegionalStoresOptionsQuery,
  useGetRegionalResponsibleQuery,
  useGetStoresByRegionalQuery,
  useGetRegisterCodeOptionsQuery,
  useGetStoresOptionsWithDetailsQuery,
  useGetStoresFilterableOptionsQuery,
} = storeInformations;

export const {
  endpoints: {
    getStoresCatalog: { select: selectGetStoresCatalog },
    getStoresOptions: { select: selectGetStoresOptions },
    getRegionalResponsible: { select: selectGetRegionalResponsible },
    getStoresResponsiblesOptions: {
      select: selectGetStoresResponsiblesOptions,
    },
    getStoresByRegional: { select: selectGetStoresByRegional },
    getRegionalStoresOptions: { select: selectGetRegionalStoresOptions },
  },
} = storeInformations;
